import { useFlags } from 'launchdarkly-react-client-sdk';

import {
  BatteryCompatibleProduct,
  useGetBatteryCompatibleProductsQuery,
} from '@phoenix/team-m/dashboard/frontend/domain/generated/graphql';
import { useCore } from '@phoenix/core/frontend/shared/feature/context/core.context';
import { useQueryContextMemo } from '@phoenix/team-m/dashboard/frontend/shared/use-query-context-memo';
import { mapProductCategory, mapProductDriveType } from '@phoenix/team-m/dashboard/frontend/util/product/product.mapper';
import { ProductCategory, ProductDriveType } from '@phoenix/team-m/dashboard/frontend/util/product/product.model';

export interface CompatibleProduct extends BatteryCompatibleProduct {
  driveType?: ProductDriveType;
  category?: ProductCategory;
}

export const mapCompatibleProducts = (products: BatteryCompatibleProduct[]): CompatibleProduct[] =>
  products?.map((product: BatteryCompatibleProduct) => ({
    ...product,
    driveType: mapProductDriveType(product.driveType),
    category: mapProductCategory(product.category),
  }));

export const useCompatibleProducts = (): { products?: CompatibleProduct[] } => {
  const {
    auth: { user },
  } = useCore();

  const stihlId = user?.stihl_id || '';
  const { 'compatible-products': flagEnabled } = useFlags();

  const [{ data }] = useGetBatteryCompatibleProductsQuery({
    variables: { limit: 9 },
    pause: !stihlId || !flagEnabled,
    context: useQueryContextMemo(process.env.NEXT_PUBLIC_TOOL_SHED_GRAPHQL_BASE_URL),
  });

  return {
    products: mapCompatibleProducts(
      data?.productRecommendations?.compatibleProducts?.batteryCompatibleProducts as BatteryCompatibleProduct[]
    ),
  };
};
